import { Component, EventEmitter, Input, Output } from '@angular/core';
import { V3InfoButton } from '../v3-info-button/v3-info-button';
import { TimeAgo } from '../time-ago/time-ago';

// Zero desktop's version of V3FinnetSubpageCard — same purpose (V3Root wraps whatever's
// projected into it, on subpages only), Zero's own card style (vars.v3-zero-card) instead
// of Finnet's accent-card, plus an optional left-aligned icon next to the title (Finnet's
// H2 has no icon) — see v3-zero-subpage-card/CLAUDE.md.
@Component({
  selector: 'app-v3-zero-subpage-card',
  templateUrl: './v3-zero-subpage-card.html',
  styleUrl: './v3-zero-subpage-card.scss',
  standalone: true,
  imports: [V3InfoButton, TimeAgo],
})
export class V3ZeroSubpageCard {
  @Input() title = '';
  @Input() icon: string | null = null;
  // The tab's overview-card timestamp; none when null.
  @Input() updatedAt: Date | null = null;
  @Input() showInfoButton = true;
  @Output() infoClicked = new EventEmitter<void>();
}
